module.exports = __webpack_public_path__ + "static/media/email-icon.8359d537.svg";